import * as React from "react";
import { styled } from "@mui/system";
import { TreeView as MUITreeView } from "@mui/x-tree-view/TreeView";
import { TreeViewProps as TreeViewPropsMUI } from "@mui/x-tree-view/TreeView";
export interface TreeViewProps extends TreeViewPropsMUI<boolean | undefined> {
  ref?: React.Ref<HTMLUListElement>;
}

export const TreeView: React.FC<TreeViewProps> = styled(
  React.forwardRef<HTMLUListElement, TreeViewProps>((props, ref) => (
    <MUITreeView ref={ref} {...props} />
  )),
  {
    name: "TreeView",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({}));
